import { render, staticRenderFns } from "./CreateSGBackups.vue?vue&type=template&id=06aa30f3"
import script from "./CreateSGBackups.vue?vue&type=script&lang=js"
export * from "./CreateSGBackups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports